module.exports = __webpack_public_path__ + "media/78_BL.2b036b1d.mp3";